<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un resultat..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button type="button" class="btn btn-primary btn-sm rounded-pill border-0 me-3 position-relative"
                    (click)="calculerMultipleResult()">
                <span class="px-2">Calculer</span>
                <span *ngIf="editedItems.size"
                      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {{ editedItems.size }}
                  </span>
            </button>
            <button class="btn btn-primary btn-sm rounded-pill border-0 me-3" (click)="btnExportResultsToExcel()">
                <span class="px-2">Exporter Résultats</span>
            </button>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openImportModal(importModal)">
                <span class="px-2">Importer Résultats</span>
            </button>

        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox [checked]="selectAll" (change)="handleSelectAll()"/>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="selectAll" (change)="handleChecked(element)"/>
                        </td>
                    </ng-container>

                    <!-- Reference Analyse Column -->
                    <ng-container matColumnDef="refAnalyse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Référence Analyse</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                readonly
                                class="form-control border-0 readonly-input"
                                [(ngModel)]="element.refAnalyse"
                                (keydown)="navigateInputs($event, i, 'refAnalyse')"
                                [id]="'refAnalyse' + i">
                        </td>
                    </ng-container>

                    <!-- Poids Column -->
                    <ng-container matColumnDef="poids">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Poids</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                (change)="addResult(element)"
                                [(ngModel)]="element.poids"
                                (keydown)="navigateInputs($event, i, 'poids')"
                                [id]="'poids' + i">
                        </td>
                    </ng-container>

                    <!-- Resultat Column -->
                    <ng-container matColumnDef="resultatBrute">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Résultat brute</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                (change)="addResult(element)"
                                [(ngModel)]="element.resultatBrute"
                                (keydown)="navigateInputs($event, i, 'resultatBrute')"
                                [id]="'resultatBrute' + i"
                            >
                        </td>
                    </ng-container>

                    <!-- Resultat Column -->
                    <ng-container matColumnDef="resultatFinale">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Resultat finale</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly
                                   class="form-control border-0"
                                   type="number"
                                   [(ngModel)]="element.resultatFinale"
                                   (keydown)="navigateInputs($event, i, 'resultatFinale')"
                                   [id]="'resultatFinale' + i"
                            >
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="formule">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Formule</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                          <input
                            class="form-control border-0"
                            [(ngModel)]="element.formule"
                            (change)="updateFormule(element)"  
                            (keydown)="navigateInputs($event, i, 'formule')"  
                            [id]="'formule' + i"
                            [value]="formules[i]?.formule || ''" 
                          >
                        </td>
                      </ng-container>
                      
                      
                      

                    <!-- Resultat Column -->
                    <ng-container matColumnDef="dateMesure">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de mesure</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.dateMesure"
                                (change)="addResult(element)"
                                (keydown)="navigateInputs($event, i, 'dateMesure')"
                                [id]="'dateMesure' + i"
                            >
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="valide">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Validé</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <select readonly
                                    class="form-control border-0"
                                    [(ngModel)]="element.valide"
                                    (keydown)="navigateInputs($event, i, 'valide')"
                                    [id]="'valide' + i"
                            >
                                <option [value]="element.valide"> {{ element.valide ? 'Oui' : 'Non' }}</option>
                            </select>
                        </td>
                    </ng-container>

                    <!-- creationDate Column -->
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Creé le</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly
                                   class="form-control border-0"
                                   type="datetime-local"
                                   [(ngModel)]="element.creationDate"
                                   (keydown)="navigateInputs($event, i, 'creationDate')"
                                   [id]="'creationDate' + i"
                            >
                        </td>
                    </ng-container>

                    <!-- updateDate Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Modifié le</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly *ngIf="element.updateDate"
                                   class="form-control border-0"
                                   type="datetime-local"
                                   [(ngModel)]="element.updateDate"
                                   (keydown)="navigateInputs($event, i, 'updateDate')"
                                   [id]="'updateDate' + i"
                            >
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined"> visibility </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary"> brush </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element.id)">
                                    <i class="material-symbols-outlined text-danger"> delete </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td *ngIf="!loadingTable" class="mat-cell" colspan="15">Aucun Analyse trouvé pour Resultats</td>
                    </tr>


                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>

<!-- modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="update()">
                <div class="row align-items-start p-0">

                    <div class="row col-sm-12 col-lg-3">

                        <h5 class="font-weight-bold">
                            Parametre infos :
                        </h5>

                        @if (parameter) {
                            <div class="py-2 col-lg-12">
                                <div>Code :</div>
                                <p>{{ parameter.codeParameter }} </p>
                            </div>
                            <div class="py-2 col-lg-12">
                                <div>Nom :</div>
                                <p>{{ parameter.name }} </p>
                            </div>
                            <div class="py-2 col-lg-12">
                                <div>Norme :</div>
                                <p>{{ parameter.norme }} </p>
                            </div>
                            <div class="py-2 col-lg-12">
                                <div>Déscription :</div>
                                <p>{{ parameter.description }} </p>
                            </div>
                        } @else {
                            Aucun parametres
                        }
                    </div>

                    <div class="row col-sm-12 col-lg-9">

                        <h5 class="font-weight-bold">
                            Modifier Resultat :
                        </h5>

                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Ref Analyse</mat-label>
                                <input readonly matInput formControlName="refAnalyse">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Formule</mat-label>
                                <mat-select formControlName="formule" required>
                                    <mat-option *ngFor="let formule of formules" [value]="formule.id">
                                        {{ formule.formule }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="editForm.get('formule')?.hasError('required')">Champ obligatoire</mat-error>
                            </mat-form-field>
                        </div>
                        
                        
                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Poids</mat-label>
                                <input matInput type="number" formControlName="poids">
                                <mat-error *ngIf="editForm.get('poids')?.hasError('required')">Champ obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Résultat brute</mat-label>
                                <input matInput type="number" formControlName="resultatBrute">
                                <mat-error *ngIf="editForm.get('resultatBrute')?.hasError('required')">Champ obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Résultat finale</mat-label>
                                <input matInput type="number" formControlName="resultatFinale">
                                <mat-error *ngIf="editForm.get('resultatFinale')?.hasError('required')">Champ
                                    obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6 mb-25">
                            <mat-form-field>
                                <mat-label>Date de mesure</mat-label>
                                <input
                                    matInput
                                    type="datetime-local"
                                    formControlName="dateMesure"
                                    (change)="updateDate($event)"
                                >
                                <mat-error *ngIf="editForm.get('dateMesure')?.hasError('required')">
                                    Champ obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Valide</mat-label>
                                <mat-select formControlName="valide">
                                    <mat-option [value]="true">Oui</mat-option>
                                    <mat-option [value]="false">Non</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Commentaire</mat-label>
                                <textarea matInput formControlName="commentaire"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 text-right">
                            <button type="submit" class="btn btn-primary">Enregistrer</button>
                        </div>
                    </div>

                </div>


            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- modal template for view -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row align-items-start">
                <div class="row col-sm-12 col-lg-3 right-border">

                    <h5 class="px-3 font-weight-bold">
                        Parametre infos :
                    </h5>
                    @if (parameter) {
                        <div class=" col-lg-12 border-top p-3">
                            <div>Code :</div>
                            <p>{{ parameter.codeParameter }} </p>
                        </div>
                        <div class=" col-lg-12 border-top p-3">
                            <div>Nom :</div>
                            <p>{{ parameter.name }} </p>
                        </div>
                        <div class=" col-lg-12 border-top p-3">
                            <div>Norme :</div>
                            <p>{{ parameter.norme }} </p>
                        </div>
                        <div class=" col-lg-12 border-top p-3">
                            <div>Déscription :</div>
                            <p>{{ parameter.description }} </p>
                        </div>
                    } @else {
                        Aucun parametres
                    }

                </div>
                <div class="row col-sm-12 col-lg-9 border-start">

                    <h5 class="px-3 font-weight-bold">
                        Resultat infos :
                    </h5>
                    <!-- Analyse Reference -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Référence Analyse :</div>
                        <p>{{ result?.refAnalyse }}</p>
                    </div>

                    <!-- Values -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Poids :</div>
                        <p>{{ result?.poids }}</p>
                    </div>
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Résultat brute :</div>
                        <p>{{ result?.resultatBrute }}</p>
                    </div>
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Résultat finale :</div>
                        <p>{{ result?.resultatFinale }}</p>
                    </div>

                    <!-- Date of Measurement -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Date de Mesure :</div>
                        <p>{{ result?.dateMesure | date : 'short' }}</p>
                    </div>


                    <!-- Validation -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Validé :</div>
                        <p>{{ result?.valide ? 'Oui' : 'Non' }}</p>
                    </div>

                    <!-- Creation Date -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Créé le :</div>
                        <p>{{ result?.creationDate | date : 'short' }}</p>
                    </div>

                    <!-- Update Date -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Modifié le :</div>
                        <p>{{ result?.updateDate | date : 'short' }}</p>
                    </div>

                    <!-- Created By -->
                    <div class="col-sm-6 col-lg-4 border-top p-3 ">
                        <div>Créé par :</div>
                        <p>{{ result?.namecreatedBy }}</p>
                    </div>

                    <!-- Comment -->
                    <div class="col-sm-6 col-lg-12 border-top p-3 ">
                        <div>Commentaire :</div>
                        <p>{{ result?.commentaire }}</p>
                    </div>
                </div>

            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Add modal template for import ResultDTO -->
<ng-template #importModal>
    <mat-card class="daxa-card border-radius border-none d-block">
        <h4>Importer les résultats</h4>
        <div class="px-4 mt-5">
            <h5 class="mt-4">
                Depuis Excel
            </h5>
            <div class="row">
                <div class="col-lg-10">
                    <input class="form-control" type="file" (change)="ex_event = $event"
                           accept=".xlsx, .xls"/>
                </div>
                <div class="col-lg-2">
                    <button [disabled]="ex_event == null" class="btn btn-primary rounded-pil"
                            (click)="btn_ImportFromExcelFile()">
                        <i class="fa-solid fa-paper-plane"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="px-4">
            <h5 class="mt-4">
                Depuis Text
            </h5>

            <div class="row">
                <div class="col-md-8">
                    <input class="form-control" type="file" (change)="event = $event" accept=".txt"/>
                </div>
                <div disabled="" class="col-md-2">
                    <button class="btn btn-primary rounded-pil" (click)="btnUpdateFromText()"
                            [disabled]="event == null">
                        <i class="fa-solid fa-paper-plane"></i>
                    </button>
                </div>
                <div disabled="" class="col-md-2">
                    <button class="btn btn-danger rounded-pil" (click)="btnAddFromText()"
                            [disabled]="event == null">
                        <i class="fa-solid fa-paper-plane"></i>
                    </button>
                </div>
            </div>
        </div>

    </mat-card>
</ng-template>
